export const iriLast = (iri) =>
  typeof iri === "string" ? iri.split("/").pop() : "";

export function upsertLangValue(arr, lang, value) {
  const safe = Array.isArray(arr) ? [...arr] : [];
  const idx = safe.findIndex((x) => x?.language === lang);
  if (idx >= 0) safe[idx] = { ...safe[idx], value };
  else safe.push({ language: lang, value });
  return safe;
}
